import React, { Component } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { produce } from 'immer'
import { RootState } from '../../store'
import rfidSvg from '../../assets/rfid.svg'

interface Props {}

type CombinedProps = Props & ConnectedProps<typeof connector>

class RfidBadge extends Component<CombinedProps> {
  render () {
    if (!this.props.hasRfidElement) return null

    return (
      <div
        className="flex items-center gap-1 bg-white px-2.5 py-1 border-2 border-red-500 text-red-600 font-semibold text-xxs tracking-widest relative z-50"
        title="RFID enabled label">
        <img
          alt=""
          className="w-4 h-4"
          style={{ filter: 'invert(28%) sepia(90%) saturate(2728%) hue-rotate(345deg) brightness(91%) contrast(91%)' }}
          src={rfidSvg} />
        RFID
      </div>
    )
  }
}

function mapStateToProps (state: RootState) {
  const { labelBuilder } = produce(state, draft => draft)
  // The RFID element, or a GS1 Barcode that writes the tag.
  const hasRfidElement = labelBuilder.markup.elements.some(element =>
    element.type === 'rfid' || (element.type === 'gs1_barcode' && !!element.gs1.rfid?.enabled)
  )

  return { hasRfidElement }
}

const connector = connect(mapStateToProps)
export default connector(RfidBadge)
